// removed by extract-text-webpack-plugin
module.exports = {"animationSpin":"src-layouts----style-module---animationSpin---2RhpM","animation":"src-layouts----style-module---animation---2DktT","animationOne":"src-layouts----style-module---animationOne---klauf","animationJiggle":"src-layouts----style-module---animationJiggle---UGtXs"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/style.module.css
// module id = 361
// module chunks = 114276838955818